export function sortSiteNamesNumerically<T extends { properties: { name?: string } }>(
  sites: T[],
): T[] {
  const sorted = sites.sort((a, b) => {
    const nameA = a.properties.name || ''
    const nameB = b.properties.name || ''

    const matchA = nameA.match(/(\d+)$/)
    const matchB = nameB.match(/(\d+)$/)

    if (matchA && matchB) {
      const numA = parseInt(matchA[1], 10)
      const numB = parseInt(matchB[1], 10)
      const result = numA - numB
      return result
    }

    const result = nameA.localeCompare(nameB)
    return result
  })

  return sorted
}
